import { parseHtml, toWebp } from "@/utils/common";
import dynamic from "next/dynamic";
const CardDots = dynamic(() => import("../CardDots"));
const ButtonLink = dynamic(() => import("@/Components/ButtonLink"));

interface BlogCardsProps {
  classname?: string;
  title?: string;
  details?: string;
  label?: any;
  link?: any;
  imageUrl?: any;
  lineClamp?: number;
}

const BlogCards: React.FC< BlogCardsProps> = ({ classname,
  title,
  details,
  label,
  link,
  imageUrl,
  lineClamp = 4,
 }) => {
  const imageWebpUrl = toWebp(imageUrl, 100);

  return (
    <div className={classname}>
      <div className="py-8 px-6 lg:pb-28 pb-[83px] h-full shadow-[0_16px_72px_-10px_#001A2D3D] bg-cover bg-no-repeat bg-center relative group overflow-hidden after:bg-[linear-gradient(180deg,_rgba(0,0,0,0.8)_39.98%,_rgba(0,0,0,0.16)_100%)] after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:right-0">
        <div
          style={{ backgroundImage: `url(${imageWebpUrl})` }}
          className="bg-cover bg-no-repeat bg-center absolute top-0 right-0 w-full h-full transition-transform duration-500 ease-in-out scale-[1] group-hover:scale-[1.15] "
        />

        <CardDots />
        <div className="relative z-10">
          <h6 className="text-heading-6 font-bold text-primary-text-white">
            {title ?? ""}
          </h6>
          <p
            className={`text-subtitle-2 font-semibold text-secondary-text-white mt-3 line-clamp-${lineClamp}`}
          >
            {parseHtml(details ?? "")}
          </p>
          {link && (
            <ButtonLink
              className="xl:mt-[19px] lg:mt-4 mt-5 font-semibold"
              label={label}
              href={link}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default BlogCards;
